var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.onImageClick}},[(_vm.photoSrc)?_c('img',{staticClass:"rounded",attrs:{"alt":_vm.alt,"id":_vm.img_id,"src":_vm.photoSrc}}):_c('img',{staticClass:"rounded",attrs:{"id":_vm.img_id,"src":require("GroomyRoot/assets/img/horse_placeholder2.jpg"),"alt":_vm.alt}})]),_c('e-fancybox',{ref:"fancybox",attrs:{"show-light-box":false,"images":[{
				thumb: _vm.photoSrc,
				src: _vm.photoSrc
			}]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }